import {engineContext} from './context.js';

(function(global){'use strict';
const VERSION='0.1.0-alpha';

function node(x){
  x=x||{};
  return Object.freeze({
    id:x.id||null,
    type:['EVIDENCE','CONCLUSION'].includes(x.type)?x.type:'EVIDENCE',
    status:['VALID','STALE','WITHDRAWN','CONFLICTED','UNKNOWN'].includes(x.status)?x.status:'UNKNOWN',
    label:x.label||null
  });
}
function edge(x){x=x||{};return Object.freeze({from:x.from||null,to:x.to||null});}

function graph(nodes,edges){
  const ns=(Array.isArray(nodes)?nodes:[]).map(node);
  const es=(Array.isArray(edges)?edges:[]).map(edge).filter(e=>e.from&&e.to);
  const ids=new Set(ns.map(n=>n.id).filter(Boolean));
  return Object.freeze({
    nodes:Object.freeze(ns),
    edges:Object.freeze(es.filter(e=>ids.has(e.from)&&ids.has(e.to)))
  });
}

function parents(g,id){return g.edges.filter(e=>e.to===id).map(e=>e.from);}
function children(g,id){return g.edges.filter(e=>e.from===id).map(e=>e.to);}

function downstream(g,startId){
  const seen=new Set(),q=[startId];
  while(q.length){
    const id=q.shift();
    for(const c of children(g,id)) if(!seen.has(c)){seen.add(c);q.push(c);}
  }
  return Object.freeze([...seen]);
}

function affectedConclusions(g,changedEvidenceIds){
  const ids=new Set();
  for(const id of (Array.isArray(changedEvidenceIds)?changedEvidenceIds:[]))
    for(const d of downstream(g,id)) ids.add(d);
  return Object.freeze(g.nodes.filter(n=>ids.has(n.id)&&n.type==='CONCLUSION'));
}

function reviewState(g,conclusionId){
  const ps=parents(g,conclusionId);
  if(!ps.length) return 'UNSUPPORTED';
  const nm=new Map(g.nodes.map(n=>[n.id,n]));
  const pnodes=ps.map(id=>nm.get(id)).filter(Boolean);
  if(pnodes.some(n=>n.status==='WITHDRAWN')) return 'INVALIDATED';
  if(pnodes.some(n=>n.status==='CONFLICTED')) return 'REVIEW_CONFLICT';
  if(pnodes.some(n=>n.status==='STALE'||n.status==='UNKNOWN')) return 'REVIEW_EVIDENCE';
  return 'SUPPORTED';
}

function explainImpact(g,changedEvidenceIds){
  const affected=affectedConclusions(g,changedEvidenceIds);
  return Object.freeze(affected.map(c=>Object.freeze({
    conclusionId:c.id,
    label:c.label,
    state:reviewState(g,c.id)
  })));
}

function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  const g=graph([
    {id:'e1',type:'EVIDENCE',status:'VALID'},
    {id:'e2',type:'EVIDENCE',status:'VALID'},
    {id:'c1',type:'CONCLUSION',status:'VALID',label:'Demand intact'},
    {id:'c2',type:'CONCLUSION',status:'VALID',label:'Thesis intact'},
    {id:'c3',type:'CONCLUSION',status:'VALID',label:'Unrelated conclusion'}
  ],[
    {from:'e1',to:'c1'},{from:'e2',to:'c1'},{from:'c1',to:'c2'}
  ]);
  ok('direct child found',children(g,'e1').includes('c1'));
  ok('parents found',parents(g,'c1').length===2);
  ok('transitive downstream found',downstream(g,'e1').includes('c2'));
  ok('unrelated conclusion excluded',!downstream(g,'e1').includes('c3'));
  ok('affected conclusions include direct',affectedConclusions(g,['e1']).some(x=>x.id==='c1'));
  ok('affected conclusions include transitive',affectedConclusions(g,['e1']).some(x=>x.id==='c2'));
  ok('valid parents support conclusion',reviewState(g,'c1')==='SUPPORTED');

  const gw=graph([{id:'e1',type:'EVIDENCE',status:'WITHDRAWN'},{id:'c1',type:'CONCLUSION'}],[{from:'e1',to:'c1'}]);
  ok('withdrawn evidence invalidates dependent conclusion',reviewState(gw,'c1')==='INVALIDATED');

  const gs=graph([{id:'e1',type:'EVIDENCE',status:'STALE'},{id:'c1',type:'CONCLUSION'}],[{from:'e1',to:'c1'}]);
  ok('stale evidence triggers review',reviewState(gs,'c1')==='REVIEW_EVIDENCE');

  const gc=graph([{id:'e1',type:'EVIDENCE',status:'CONFLICTED'},{id:'c1',type:'CONCLUSION'}],[{from:'e1',to:'c1'}]);
  ok('conflicted evidence remains conflict review',reviewState(gc,'c1')==='REVIEW_CONFLICT');

  ok('unsupported conclusion stays unsupported',reviewState(g,'c3')==='UNSUPPORTED');
  ok('impact explanation is scoped',explainImpact(g,['e1']).length===2);
  ok('graph removes dangling edges',graph([{id:'e1'}],[{from:'e1',to:'missing'}]).edges.length===0);

  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}

const API={VERSION,node,edge,graph,parents,children,downstream,affectedConclusions,reviewState,explainImpact,selfTest};
try{API.selfTestResult=selfTest()}catch(e){API.bootstrapError=String(e&&e.stack||e)}
global.ZooInvestEvidenceDependencyGraphEngine=Object.freeze(API);
})(engineContext);